/* eslint-disable @typescript-eslint/no-explicit-any */
import { getEnv } from '@ctct/ctct-helpers';

const MYACCOUNT_BASE_URL = `https://app${getEnv()}constantcontact.com/pages/myaccount`;

export const BUYNOW_BASE_URL = `${MYACCOUNT_BASE_URL}/base/buynow`;

export const PAYFLOW_BASE_URL = `${MYACCOUNT_BASE_URL}/base/purchase`;

export const CHANGE_PAYMENT_PLAN_BASE_URL = `${MYACCOUNT_BASE_URL}/base/payment-plan`;

export const BILLING_BASE_URL = `${MYACCOUNT_BASE_URL}/billing`;

const localSecureDomain = (import.meta as any).env?.VITE_LOCAL_SECURE_DOMAIN;

export const SECURE_BASE_URL = localSecureDomain || `https://secure${getEnv()}constantcontact.com`;
